"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SportsItem = _interopRequireDefault(require("./schedule-list-items/SportsItem"));
var _SeriesItem = _interopRequireDefault(require("./schedule-list-items/SeriesItem"));
var _MovieItem = _interopRequireDefault(require("./schedule-list-items/MovieItem"));
var _helpers = require("../../utils/helpers");
var _ScheduleListModule = _interopRequireDefault(require("./../../scss/layouts/ScheduleList.module.scss"));
require("./../../scss/layouts/ScheduleList.css");
// import { determineSeriesPrefix } from '../../utils/program-helpers'

const determineCTA = scheduleItem => {
  var _scheduleItem$video, _scheduleItem$content, _scheduleItem$content2, _scheduleItem$content3, _scheduleItem$content4, _scheduleItem$content5, _scheduleItem$content6, _scheduleItem$content7, _scheduleItem$content8, _scheduleItem$content9, _scheduleItem$content10;
  if ((_scheduleItem$video = scheduleItem.video) !== null && _scheduleItem$video !== void 0 && _scheduleItem$video.brightcove_id) return {
    label: "Watch Preview",
    type: 'play-video',
    href: '',
    relatedResourceId: scheduleItem.video.brightcove_id,
    position: 'inline'
  };
  if (scheduleItem !== null && scheduleItem !== void 0 && scheduleItem.showUpcoming && (scheduleItem === null || scheduleItem === void 0 ? void 0 : scheduleItem.program_class) === 'Episode') return {
    label: '',
    //`View Upcoming Airings`
    type: '',
    //'show-modal',
    href: '',
    relatedResourceId: '',
    //determineSeriesPrefix(scheduleItem.series_prefix),
    relatedResourceType: '',
    //'series',
    position: '' //'inline',
  };
  if (scheduleItem !== null && scheduleItem !== void 0 && scheduleItem.showUpcoming && (scheduleItem === null || scheduleItem === void 0 ? void 0 : scheduleItem.program_class) === 'Film') return {
    label: '',
    //`View Upcoming Airings`,
    type: '',
    //'show-modal',
    href: '',
    relatedResourceId: '',
    //scheduleItem.title_code,
    relatedResourceType: '',
    //'film',
    position: '' //'inline',
  };
  if (((scheduleItem === null || scheduleItem === void 0 || (_scheduleItem$content = scheduleItem.content) === null || _scheduleItem$content === void 0 ? void 0 : _scheduleItem$content.external_link) !== undefined && (scheduleItem === null || scheduleItem === void 0 || (_scheduleItem$content2 = scheduleItem.content) === null || _scheduleItem$content2 === void 0 ? void 0 : _scheduleItem$content2.external_link) !== '' || (scheduleItem === null || scheduleItem === void 0 || (_scheduleItem$content3 = scheduleItem.content) === null || _scheduleItem$content3 === void 0 ? void 0 : _scheduleItem$content3.slug) !== undefined && (scheduleItem === null || scheduleItem === void 0 || (_scheduleItem$content4 = scheduleItem.content) === null || _scheduleItem$content4 === void 0 ? void 0 : _scheduleItem$content4.slug) !== '') && !(scheduleItem !== null && scheduleItem !== void 0 && (_scheduleItem$content5 = scheduleItem.content) !== null && _scheduleItem$content5 !== void 0 && _scheduleItem$content5.prevent_detail_page)) return {
    label: "Learn More",
    type: scheduleItem !== null && scheduleItem !== void 0 && (_scheduleItem$content6 = scheduleItem.content) !== null && _scheduleItem$content6 !== void 0 && _scheduleItem$content6.external_link ? 'external-link' : 'internal-link',
    href: scheduleItem !== null && scheduleItem !== void 0 && (_scheduleItem$content7 = scheduleItem.content) !== null && _scheduleItem$content7 !== void 0 && _scheduleItem$content7.external_link ? scheduleItem === null || scheduleItem === void 0 || (_scheduleItem$content8 = scheduleItem.content) === null || _scheduleItem$content8 === void 0 ? void 0 : _scheduleItem$content8.external_link : scheduleItem.program_class === 'Episode' ? "/show/".concat(scheduleItem === null || scheduleItem === void 0 || (_scheduleItem$content9 = scheduleItem.content) === null || _scheduleItem$content9 === void 0 ? void 0 : _scheduleItem$content9.slug) : "/movie/".concat(scheduleItem === null || scheduleItem === void 0 || (_scheduleItem$content10 = scheduleItem.content) === null || _scheduleItem$content10 === void 0 ? void 0 : _scheduleItem$content10.slug),
    position: 'inline'
  };
  return {
    label: "",
    type: '',
    href: '',
    position: ''
  };
};
function ScheduleList(_ref) {
  let {
    schedule = [],
    handleClicks = () => true,
    exiting = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(_ScheduleListModule.default['schedule-list'], " schedule-list"),
    "data-state": exiting ? 'exiting' : 'idle'
  }, schedule.length !== 0 && schedule.map(scheduleItem => {
    const runTimeStr = (0, _helpers.getMinutesFromStr)(scheduleItem.element_length);
    const strListArr = determineCTA(scheduleItem).type === '' ? [runTimeStr, scheduleItem.rating] : [runTimeStr, scheduleItem.rating, '&nbsp;'];
    // if there isn't a CTA, don't force extra pipe separator

    if (scheduleItem.program_class === 'Episode') {
      return /*#__PURE__*/_react.default.createElement(_SeriesItem.default, {
        scheduleItem: scheduleItem,
        styles: _ScheduleListModule.default,
        strListArr: strListArr,
        handleClicks: handleClicks,
        determineCTA: determineCTA,
        key: "schedule-list-".concat(scheduleItem.id)
      });
    } else if (scheduleItem.program_class === 'Film' || scheduleItem.program_class === 'Movie' || scheduleItem.program_class === 'Special') {
      return /*#__PURE__*/_react.default.createElement(_MovieItem.default, {
        scheduleItem: scheduleItem,
        styles: _ScheduleListModule.default,
        strListArr: strListArr,
        handleClicks: handleClicks,
        determineCTA: determineCTA,
        key: "schedule-list-".concat(scheduleItem.id)
      });
    } else if (scheduleItem.program_class === 'Sports') {
      return /*#__PURE__*/_react.default.createElement(_SportsItem.default, {
        scheduleItem: scheduleItem,
        styles: _ScheduleListModule.default,
        strListArr: strListArr,
        handleClicks: handleClicks,
        determineCTA: determineCTA,
        key: "schedule-list-".concat(scheduleItem.id)
      });
    } else {
      return null;
    }
  }));
}
var _default = exports.default = ScheduleList;